import type { Metadata } from 'next';
import { routePolicy } from './policy/routePolicy';

export const SERVICE_SCREEN_ROBOTS = { index: false, follow: true } as const satisfies Metadata['robots'];
export const NOINDEX_X_ROBOTS_TAG = 'noindex, follow';
export const HOST_NOINDEX_X_ROBOTS_TAG = 'noindex, nofollow';

export const isServiceScreen = (appPath: string): boolean => {
  const policy = routePolicy(appPath);
  return policy.metadataStrategy === 'private' || policy.metadataStrategy === 'error';
};

export const isClosedForHost = (appPath: string, host: string): boolean =>
  appPath === '/contacts' && host.split(':')[0] !== 'cs-shot.uz';

export const isNoindexScreen = (appPath: string, host: string): boolean =>
  routePolicy(appPath).indexability === 'noindex' || isServiceScreen(appPath) || isClosedForHost(appPath, host);
